(function() {
  function updateBadge(count) {
    // Desktop sub-nav cart count
    var desktopCount = document.querySelector('.evdnce-sub-nav__cart-count');
    var cartLink = document.querySelector('.evdnce-sub-nav__util-link[data-cart-link]');

    if (count > 0) {
      if (!desktopCount && cartLink) {
        desktopCount = document.createElement('span');
        desktopCount.className = 'evdnce-sub-nav__cart-count';
        cartLink.appendChild(desktopCount);
      }
      if (desktopCount) desktopCount.textContent = count > 99 ? '99+' : count;
    } else {
      if (desktopCount) desktopCount.remove();
    }

    // Mobile cart count
    var mobileCount = document.querySelector('.evdnce-mobile-cart-count');
    var mobileCartLink = document.querySelector('.evdnce-mobile-util-icon[aria-label="Cart"]');

    if (count > 0) {
      if (!mobileCount && mobileCartLink) {
        mobileCount = document.createElement('span');
        mobileCount.className = 'evdnce-mobile-cart-count';
        mobileCartLink.appendChild(mobileCount);
      }
      if (mobileCount) mobileCount.textContent = count > 99 ? '99+' : count;
    } else {
      if (mobileCount) mobileCount.remove();
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateBadge(cart.item_count); })
      .catch(function() {});
  }

  // Run on load
  fetchAndUpdate();

  // Watch the theme's own cart badge for any changes
  function watchThemeBadge() {
    var badge = document.querySelector('.cart-count-bubble, .cart-count-badge, [data-cart-count]');
    if (badge) {
      new MutationObserver(function() {
        var n = parseInt(badge.textContent.trim(), 10);
        if (!isNaN(n)) updateBadge(n);
      }).observe(badge, { childList: true, subtree: true, characterData: true });
    }
  }

  // Listen for ALL cart-related events the theme might fire
  var cartEvents = [
    'cart:refresh', 'cart:updated', 'cart:change',
    'cart-update', 'cart-add', 'CartDrawer:open',
    'cart:item-added'
  ];
  cartEvents.forEach(function(evt) {
    document.addEventListener(evt, fetchAndUpdate);
    window.addEventListener(evt, fetchAndUpdate);
  });

  // Intercept fetch calls to cart endpoints
  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    )) {
      result.then(function(resp) {
        // Clone so we don't consume the body
        setTimeout(fetchAndUpdate, 100);
        setTimeout(fetchAndUpdate, 500);
        return resp;
      }).catch(function() {});
    }
    return result;
  };

  // Also intercept XMLHttpRequest for older cart implementations
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update')
    )) {
      this.addEventListener('load', function() {
        setTimeout(fetchAndUpdate, 100);
        setTimeout(fetchAndUpdate, 500);
      });
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function() {
    watchThemeBadge();
    fetchAndUpdate();
  });

  // Light poll as fallback — only when page is visible
  var lastCount = -1;
  setInterval(function() {
    if (document.hidden) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count !== lastCount) {
          lastCount = cart.item_count;
          updateBadge(cart.item_count);
        }
      }).catch(function() {});
  }, 2000);
})();
